import { gql } from '@apollo/client';

export const SUBSCRIPTION_STREAM_CHAT_MESSAGE = gql`
  subscription StreamChatMessage($input: ChatStreamInput!) {
    streamChatMessage(input: $input) {
      chunk
      conversation_id
      is_complete
      error
    }
  }
`;
